export default __webpack_public_path__ + "static/media/skill-crossroad.dbef1da9.svg";